import { createSelector } from 'reselect'

export const getAlgolia = (state: Record<string, any>): Record<string, any> => state.algolia || {}

export const getSelectedFacets = createSelector(
  getAlgolia,
  (pageData): Record<string, any> => {
    return pageData.selectedFacets || {}
  }
)
export const getSelectedFacetsPriceMinMax = createSelector([getSelectedFacets], (selectedFacets): {
  priceMin: number | null
  priceMax: number | null
} => {
  const [min, max] = (selectedFacets.price || '').split('-')
  const minString = max && typeof min === 'number' && !isNaN(min) ? min : null
  const maxString = typeof max === 'number' && !isNaN(max) ? max : null
  return {
    priceMin: minString,
    priceMax: maxString,
  }
})
